export default __webpack_public_path__ + "static/media/CheckGreenIcon.6a2f9958.svg";